module.exports = __webpack_public_path__ + "static/img/pf.dc8bfeb8.jpg";